module.exports = __webpack_public_path__ + "img/previous.7f9d1dba.svg";